module.exports = __webpack_public_path__ + "static/media/Natugee_preview.0a272a3c.jpg";